import ImageWrapper from "@/components/ImageWrapper";
import { minToHourConverter } from "@/helpers/useCommonFunctions";
import {
  useAppDispatch,
  useAppSelector,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "@/utils/hooks/reactUseCustomHooks";
import {
  createRecipeListAction,
  getRecipeListAction,
} from "@/utils/redux/recipes/addtolistSlice/actions";
import {
  AutoComplete,
  Box,
  Button,
  Card,
  CardHeader,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Text,
} from "@dxp-feed/ui";
import Link from "@/components/Link";
import { getfetchFavouritesRecipes } from "@/utils/redux/recipes/recipeSlice/actions";
import { HighlightText } from "@/components/Header/Search/HighlightText";
import useValidation from "../../common/validation";
import { AlgoliaSingleIndexType } from "@/utils/types/algolia";
import { algoliaConfig } from "@/services/algolia/config";
import { searchBySingleIndex } from "@/services/algolia";
import { setToastMessage } from "@/utils/redux/recipes/toastMessageSlice";
import { DEFAULT_RECIPE_FILTER, RecipeImage } from "@/utils/constant";
import useNetwork from "../../common/commonRecipeFunctions/useNetwork";
import { useGigyaToken } from "../../common/commonRecipeFunctions/getGigyaToken";
import AutoCompleteCard from "../Cards/AutoCompleteCard";
import { usePathname } from "next/navigation";
import { setDataLayerSlice } from "@/utils/redux/dataLayerSlice";
import {
  setModifiedFavourite,
  setModifiedRecipeList,
  setOriginalRecipeList,
  setSearchRecipe,
} from "@/utils/redux/recipes/addtolistSlice";
import {
  addDataLayerOfRecipeToList,
  addDataLayerRecipeAddList,
} from "@/helpers/dataLayer";
import { sendSalesforceInteraction } from "@/helpers/cdnSdk";
import { getUTMParameter } from "@/helpers/getUTMParameters";
import { recipeDetailData,mealPlanDefautMessage, recipeModalData} from "@/utils/aemDefaultData";

const CreateListModal = ({
  isModalOpen,
  isEditing,
  setIsEditing,
  addRecipeToList = false,
  recipeByListId = [],
  updatedListName,
  componentName,
  favouriteOpen = false,
  closeFavModal,
  closeCreateListModal,
  setTheProgressModal,
  folderId,
  setFolderId,
  disableButtonsFolder,
  setDisableButtonsFolder,
  recipeListName,
  setRecipeListName,
  selectRecipe,
  setSelectRecipe,
  isNewRecipeAdded,
  setIsNewRecipeAdded,
  disableButtonRecipe,
  setDisableButtonRecipe,
  searchRecipeData,
  setSearchRecipeData,
  saveRecipesToFolder,
  bodyRef,
  disableBackgroundScroll,
  enableBackgroundScroll,
  disableCloseButton,
  setDisableCloseButton,
  closeAfterSearch,
}: any) => {
  const [type, setType] = useState<string | null>("Add");
  const inputRef = useRef<HTMLInputElement | null>(null);
  const editRef = useRef<HTMLInputElement | null>(null);
  const { messages: MESSAGE } = useAppSelector((state) => state.messageSlice);
  const [validationError, setValidationError] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [search, setSearch] = useState<string>("");
  const [noResultFound, setNoResultFound] = useState(false);
  const dispatch = useAppDispatch();
  const { getAccountInfo, resetLoginParams } = useGigyaToken();
  const { validateInput, valueWithoutInitalSpace } = useValidation();
  const { aemRecipeModelData: aemModalData } = useAppSelector(
    (state) => state.AemModalSlice
  );
  const { uid: Uid } = useAppSelector((state) => state.gigyaslice);
  const { originalRecipeList, modifiedRecipeList, originalFavourite } =
    useAppSelector((state) => state.RecipeToList);
  const { messages } = useAppSelector((state) => state.messageSlice);
  const isOnline = useNetwork();
  const pathname = usePathname();

  useEffect(() => {
    if (isModalOpen && inputRef.current) {
      inputRef.current.focus(); // Automatically focus the input when the modal is open.
    }
    if (isModalOpen && editRef.current) {
      editRef.current.focus(); // Automatically focus the Edit icon when the list is saved.
    }
  }, [isModalOpen, isEditing]);

  const deleteSelectRecipe = (objectID: string) => {
    if (selectRecipe.length == 1) {
      setIsNewRecipeAdded(false);
    }
    setSelectRecipe((prev: any) =>
      prev.filter((item: any) => item?.objectID !== objectID)
    );
  };

  const toggleEditMode = () => {
    setType("Edit");
    setIsEditing(true);
    setDisableButtonRecipe(true);
  };
  /**
   * Handles recipe search from algolia with a debounce mechanism.
   */
  type SearchEvent =
    | React.ChangeEvent<HTMLInputElement>
    | React.FormEvent<HTMLFormElement>;
  const debounceRef = useRef<NodeJS.Timeout | null>(null);
  const searchRecipe = useCallback(
    async (e: SearchEvent) => {
      let value;
      if ("target" in e && e.target instanceof HTMLInputElement) {
        value = e.target.value;
      } else {
        value = search;
      }
      if (value.trimStart().length !== value.length) return;
      setSearch(value);
      setNoResultFound(false);

      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(async () => {
        if (value) {
          const query: AlgoliaSingleIndexType = {
            indexName: algoliaConfig.indexNames.recipes,
            searchParams: {
              query: value,
              filters: DEFAULT_RECIPE_FILTER,
            },
          };
          try {
            const response = await searchBySingleIndex(query);
            if (response?.hits) {
              setSearchRecipeData(response.hits);
              setNoResultFound(response.hits.length === 0);
            } else {
              setSearchRecipeData([]);
              setNoResultFound(true);
            }
          } catch (err) {
            // handle/search error path
            setSearchRecipeData([]);
            setNoResultFound(true);
          }
        } else {
          setSearchRecipeData([]);
          setNoResultFound(true);
        }
      }, 600);
    },
    [searchBySingleIndex, algoliaConfig]
  );

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  const closeModal = () => {
    if (folderId && !isNewRecipeAdded && !addRecipeToList) {
      dispatch(
        setToastMessage({
          message: `${messages?.RECIPE_LIST_CREATE ?? mealPlanDefautMessage[0]?.recipeListCreate}`,
          status: "",
        })
      );
    }
    
    if (folderId && isNewRecipeAdded) {
      setTheProgressModal(selectRecipe.length);
    } else {
      setFolderId(null);
      setSelectRecipe([]);
      if (componentName === "favourite") {
        closeFavModal();
      }
    }
    closeCreateListModal();
    setSearch("");
    setValidationError("");
    setType("Add");
    setDisableButtonRecipe(true);
    // Allow Scrolling
    enableBackgroundScroll();
  };

  const clearQuery = () => {
    if (!search) return;
    setSearch("");
    setSearchRecipeData([]);
  };
  const onFocus = () => {
    // setSearchRecipeData([]);
    // Restrict background Scrolling
    disableBackgroundScroll();
  };
  const addRecipe = (recipe: any) => {
    setSelectRecipe((prev: any) => {
      // Check if the recipe ID already exists in the list
      if (prev.some((item: any) => item.objectID === recipe.objectID)) {
        setError(`${messages?.ERROR_MESSAGE?.RECIPE_ALREADY_EXIST ?? mealPlanDefautMessage[0]?.recipeAlreadyExists}`);
        return prev;
      }

      setError(null);
      return [...prev, recipe];
    });
    setIsNewRecipeAdded(true);
    setSearchRecipeData((prev: any[]) =>
      prev.filter((item) => item?.objectID !== recipe?.objectID)
    );
  };

  /**
   * @description  This function is called when input is changed.
   */
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      value,
      error: { regError, initialSpaceError },
    } = valueWithoutInitalSpace(e.target.value);
    setRecipeListName(value);
    setValidationError("");
    const error = validateInput(value, regError, initialSpaceError);
    setValidationError(error);
    if (value !== recipeListName) setDisableButtonsFolder(!!error);
  };

  /**
   * @description Get Structure Data
   */

  const getModifiedRecipe = (result: any, recipeList: any[]) => {
    const newRecipe = {
      id: result?.payload?.data?.id,
      list_name: result?.payload?.data?.list_name,
      created_at: result?.payload?.data?.created_at,
      recipes: [],
    };

    if (!newRecipe.id) {
      return [newRecipe, ...recipeList];
    }

    const existingIndex = recipeList.findIndex(
      (item) => item.id === newRecipe.id
    );

    if (existingIndex !== -1) {
      const updatedList = [...recipeList];
      const existingItem = updatedList[existingIndex];

      updatedList[existingIndex] = {
        ...existingItem,
        ...newRecipe,
        recipes: existingItem.recipes,
      };
      return updatedList;
    }

    return [newRecipe, ...recipeList];
  };

  /**
   * @description Saves the recipe list name to the database.
   */
  const saveRecipeListName = async () => {
    /** Check if User is online */
    if (!isOnline) {
      dispatch(
        setToastMessage({
          message: `${MESSAGE?.ERROR_MESSAGE?.OFFLINE_ERROR ?? mealPlanDefautMessage[0]?.offlineError}`,
          status: "",
        })
      );
      return;
    }
    setDisableButtonsFolder(true);
    const { idToken: token } = await getAccountInfo();
    const payload = {
      list_name: recipeListName,
      id: folderId,
      type: folderId ? type : "Add",
      token,
    };

    const result: any = await dispatch(createRecipeListAction(payload));
    if (result?.payload?.status == 401) {
      resetLoginParams();
      return;
    }
    if (result?.payload && result?.payload?.status == 409) {
      setValidationError(MESSAGE?.ERROR_MESSAGE?.RECIPE_LIST_ALREADY_EXIST ?? mealPlanDefautMessage[0]?.recipeListAlreadyExist);
    } else if (result?.payload?.status == 200) {
      setFolderId(result?.payload?.data?.id);
      setIsEditing(false);
      setDisableButtonRecipe(false);
      //------- Refactor needed -----------
      const getOriginalEnrichList = getModifiedRecipe(
        result,
        originalRecipeList
      );
      dispatch(setOriginalRecipeList(getOriginalEnrichList));
      const enrichedList = getModifiedRecipe(result, modifiedRecipeList);
      dispatch(setModifiedRecipeList(enrichedList));

      //- My recipe list
      if (pathname.includes("/recipes/my-recipe-lists")){
        dispatch(setSearchRecipe(""));
        dispatch(setModifiedRecipeList(getOriginalEnrichList));
        dispatch(setModifiedFavourite(originalFavourite));
        closeAfterSearch();
      }

      //---------------------------------------
      if (componentName !== "favourite" && addRecipeToList) {
        await updatedListName(recipeListName);
      }
      const resultList = await dispatch(getRecipeListAction({ token }));
      if (resultList?.payload?.status == 401) {
        resetLoginParams();
        return;
      }
      const resultFav = await dispatch(getfetchFavouritesRecipes({ token }));
      if (resultFav?.payload?.status == 401) {
        resetLoginParams();
        return;
      }

      addDataLayerRecipeAddList({
        event: "button_click",
        click_text: "create a list",
        list_name: recipeListName,
        page_title: document.title,
        page_type: "Recipe List",
      });
      sendSalesforceInteraction({
        name: "listCreated",
        banner: process.env.NEXT_PUBLIC_MERCHANT_IDENTIFIER,
        isAnonymous: Uid ? 0 : 1,
        gigyaUid: Uid,
        listName: recipeListName,
        screenName: document.title,
        screenClass: window.location.href,
        utmSource: getUTMParameter("utm_source"),
        utmMedium: getUTMParameter("utm_medium"),
        utmCampaign: getUTMParameter("utm_campaign"),
      });
    }
  };
  const dataLayePageSection = () => {
    dispatch(setDataLayerSlice("My Recipe Lists"));
  };
  return (
    <Dialog
      isOpen={isModalOpen}
      onClose={closeModal}
      className="max-w-full md:max-w-[708px] rounded-none md:rounded-lg p-0"
      positionClass="items-end md:items-center "
      closeOnOverlayClick={false}
    >
      <DialogHeader className="border-grey250 border-b-2 px-6 py-4">
        <Box as="div" className="flex gap-1 flex-col">
          {!favouriteOpen && (
            <Text as="p" className="text-[14px]">
              {aemModalData?.myRecipeList ?? recipeModalData[0]?.myRecipeList}
            </Text>
          )}
          {isEditing && !favouriteOpen ? (
            <Box as="div" className="relative flex items-start">
              <Box as="div" className="flex flex-col">
                <label htmlFor="Type here" className="sr-only">
                  {aemModalData?.placeholderText ?? recipeModalData[0]?.placeholderText}
                </label>
                <Input
                  id="Type here"
                  type="text"
                  autoComplete="off"
                  value={recipeListName}
                  ref={inputRef}
                  onChange={handleInputChange}
                  className="w-full border-grey350 rounded py-1 px-2 min-w-[140px] 3xs:min-w-[170px] max-w-[140px] 3xs:max-w-[170px]  min-h-[40px] placeholder-grey900 text-brandBlack"
                  placeholder={`${aemModalData?.placeholderText ?? recipeModalData[0]?.placeholderText}`}
                />
                {validationError && (
                  <Box
                    as="div"
                    role="alert"
                    aria-live="assertive"
                    className="text-red300 text-[12px] pt-[2px] min-w-[140px] max-w-[140px] 3xs:min-w-[170px] 3xs:max-w-[170px]"
                  >
                    {validationError}
                  </Box>
                )}
              </Box>
              <Button
                variant={"outline"} // Dynamically set variant
                className={`ml-2 text-[14px] h-10 w-[79px] hover:text-brandBlack
                   ${disableButtonsFolder ? "" : " before:bg-brandPrimary hover:border-brandPrimary focus:text-brandWhite hover:text-brandWhite focus:bg-transparent focus:border-brandPrimary    border-brandSecondary text-brandSecondary"}`}
                onClick={saveRecipeListName}
                aria-label={aemModalData?.save ?? recipeModalData[0]?.save}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    void saveRecipeListName();
                  }
                }}
                disabled={disableButtonsFolder}
                // Dynamically disable/enable button
              >
                {aemModalData?.save ?? recipeModalData[0]?.save}
                {/* Save */}
              </Button>
            </Box>
          ) : (
            <Text
              as="h2"
              className="text-[20px] font-bold"
              aria-label={recipeListName}
            >
              {recipeListName}
              <Button
                variant="icon"
                size="none"
                ref={editRef}
                onClick={toggleEditMode}
                aria-label="Edit My Recipe List"
              >
                {!favouriteOpen && (
                  <Text
                    as="span"
                    className="demo-icon icon-edit pl-2 text-[18px] min-w-5 min-h-5 text-brandBlack cursor-pointer"
                  ></Text>
                )}
              </Button>
            </Text>
          )}
        </Box>
        <Button
          className="text-brandSecondary font-bold text-lg rounded-none"
          onClick={closeModal}
          aria-label="Close modal"
          variant="icon"
          size="none"
          disabled={disableCloseButton}
        >
          <Text
            as="span"
            className="demo-icon icon-close text-brandBlack text-[14px]"
          ></Text>
        </Button>
      </DialogHeader>
      {error && (
        <p className="bg-red300 text-brandWhite text-[12px] text-center py-1 mx-6 mt-4">
          {error}
        </p>
      )}
      {/* <p className="bg-red300 text-brandWhite text-[12px] text-center py-1 mx-6 mt-4">{error}</p> */}
      <DialogBody className="px-6 py-4">
        {selectRecipe && selectRecipe.length > 0 && (
          <AutoCompleteCard
            selectRecipe={selectRecipe}
            deleteSelectRecipe={deleteSelectRecipe}
          />
        )}
        <Box className="font-bold">{aemModalData?.searchRecipesTitle ?? recipeModalData[0]?.searchRecipesTitle}</Box>
        <Box className="mt-2 relative flex flex-col" ref={bodyRef}>
          <AutoComplete
            submitLabel="Search Recipes List"
            closeLabel="Close search bar"
            placeHolderText="Search"
            autoComplete="off"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // Prevent the default form submission behavior
              }
            }}
            autoSuggestion={false}
            onChange={(e) => {
              e.preventDefault();
              void searchRecipe(e);
            }}
            value={search}
            handleClose={clearQuery}
            onFocus={onFocus}
            // disable={disableAutoCompleted}
            className={`
          [&_input]:h-[40px] [&_input]:z-[9999] [&_input]:text-[16px] !static [&_input]:w-full  [&_input]:pl-[16px] [&_input]:pr-[40px] [&_.dropDown]:rounded-[0_0_8px_8px]  [&_.dropDown]:!p-0 [&_.dropDown]:pb-4 [&_input]:border-solid [&_input]:border-[1px] [&_input]:border-grey350 [&_input]:rounded [&_.search-input]:outline-none [&_.dropDown]:relative md:[&_.dropDown]:absolute ${noResultFound ? "[&_.dropDown]:shadow-xl" : ""}
          
          `}
            handleSubmit={(e) => {
              e.preventDefault();
              void searchRecipe(e);
            }}
          >
            {searchRecipeData?.length ? (
              <Box
                as="div"
                className="md:mx-6 mt-2 m-0 max-h-[180px] custom-scroll "
              >
                <Box as="div" className="grid grid-cols-1 gap-2 w-[100%]">
                  {searchRecipeData &&
                    searchRecipeData.length > 0 &&
                    searchRecipeData.map((item: any, index: number) => {
                      const alreadyExist = [
                        ...recipeByListId,
                        ...selectRecipe,
                      ].some(
                        (recipe: any) => recipe.objectID === item.objectID
                      );

                      return (
                        <Card
                          key={item?.title + index}
                          className="relative flex w-full shadow-none rounded-[12px] border border-grey350 bg-brandWhite"
                        >
                          <Box
                            as="div"
                            className="relative bg-grey300 min-h-[72px] overflow-hidden pl-[80px] 3xs:pl-[100px] xs:pl-[128px]"
                          >
                            <ImageWrapper
                              src={`${RecipeImage + item?.featuredImage || item?.featuredImage}`}
                              alt={
                                item?.title
                                  ? `${item.title} - a delicious recipe`
                                  : "A recipe from our collection"
                              }
                              fill
                              className="absolute top-0 left-0 object-cover"
                            />
                          </Box>
                          <CardHeader
                            className={`border-none w-full py-2 xs:py-0 gap-1 xs:gap-3 flex flex-col xs:flex-row items-start xs:items-center justify-center xs:justify-between px-0 pr-2 pl-3 ${alreadyExist ? "bg-grey100" : ""}`}
                          >
                            <Box
                              as="div"
                              className="text-[14px] font-normal [&>strong]:font-bold line-clamp-1 xs:line-clamp-2"
                            >
                              <HighlightText
                                text={item?.title ?? ""}
                                query={search ?? ""}
                              />
                            </Box>
                            <Text as="ul" className="flex items-center">
                              {item?.cooking?.totalTime ? (
                                <>
                                  <Text
                                    as="li"
                                    className="flex items-center w-full justify-start xs:justify-end xs:min-w-[110px]"
                                  >
                                    <Text
                                      as="span"
                                      className="demo-icon icon-clock text-[19px] font-light flex items-center"
                                    ></Text>
                                    <Text
                                      as="span"
                                      className="py-0 px-2 text-[14px]"
                                    >
                                      {minToHourConverter(
                                        item?.cooking?.totalTime
                                      )}
                                    </Text>
                                  </Text>
                                  <Text as="span">|</Text>
                                </>
                              ) : (
                                ""
                              )}
                              {alreadyExist ? (
                                <Link
                                  onClick={dataLayePageSection}
                                  href={
                                    item?.pageSlug
                                      ? `/recipes/${item?.pageSlug}`
                                      : `/not-found`
                                  }
                                  target="_blank"
                                  className="min-w-[40px] min-h-[30px] xs:min-w-[48px] xs:min-h-[48px] flex items-center justify-center"
                                  aria-label={`Go to my recipe lists page`}
                                >
                                  <Text
                                    as="span"
                                    className={`demo-icon icon-forward-arrow text-[12px] xs:text-[14px] text-brandBlack min-w-[30px] min-h-[30px] xs:min-w-[40px] xs:min-h-[40px] flex items-center justify-center rounded-full ${alreadyExist ? "bg-brandWhite pr-1" : ""}`}
                                  ></Text>
                                </Link>
                              ) : (
                                <Text
                                  tabIndex={0}
                                  aria-label={`Add ${item?.title} recipe `}
                                  onClick={() => addRecipe(item)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      addRecipe(item);
                                    }
                                  }}
                                  as="span"
                                  className="tab cursor-pointer demo-icon icon-plus text-[14px] text-brandBlack min-w-[48px] min-h-[20px] xs:min-h-[48px] flex items-center justify-center"
                                ></Text>
                              )}
                            </Text>
                          </CardHeader>
                        </Card>
                      );
                    })}
                </Box>
              </Box>
            ) : null}

            {noResultFound && search != "" && !searchRecipeData.length ? (
              <Box
                as="div"
                className="mx-6 py-6 break-words break-all whitespace-normal"
              >
                {`${aemModalData?.noSearchResult ?? recipeDetailData[0]?.noSearchResult} "${search.trim()}"`}
              </Box>
            ) : null}
          </AutoComplete>
          {/* Buttons For Mobile View */}
          <Box as="div" className="flex mt-2 md:hidden">
            {pathname !== "/recipes" && (
              <Button
                asChild
                variant="outline"
                className="gap-3 flex text-[14px] font-normal group"
              >
                <Link
                  href="/recipes"
                  className="text-[14px] font-normal focus:bg-transparent before:bg-brandPrimary hover:border-brandPrimary"
                >
                  {aemModalData?.browseRecipes ?? recipeModalData[0]?.browseRecipes}
                </Link>
              </Button>
            )}
          </Box>
        </Box>
      </DialogBody>
      <DialogFooter className="border-grey250 border-t-2 py-4">
        <Box
          as="div"
          className="flex flex-col md:flex-row w-full justify-center xs:justify-between gap-4 md:gap-6 px-6 "
        >
          <Box as="div" className="hidden md:flex ">
            {pathname !== "/recipes" && (
              <Button
                asChild
                variant="outline"
                className="gap-3 flex text-[14px] font-normal group"
              >
                <Link
                  href="/recipes"
                  className="text-[14px] font-normal focus:bg-transparent  before:bg-brandPrimary hover:border-brandPrimary border-brandPrimary text-brandPrimary"
                >
                  {aemModalData?.browseRecipes ?? recipeModalData[0]?.browseRecipes}
                  {/* Browse Recipes */}
                </Link>
              </Button>
            )}
          </Box>

          <Box as="div" className="flex gap-4">
            <Button
              variant={
                disableButtonRecipe || !!validationError ? "primary" : "primary"
              }
              className={`gap-3 flex text-[14px] hover:text-brandBlack font-normal h-10 group w-full md:auto  ${
                disableButtonRecipe ||
                !!validationError ||
                !selectRecipe?.length
                  ? ""
                  : "bg-brandPrimary border-brandPrimary focus:bg-brandPrimary hover:bg-brandPrimary hover:border-brandPrimary hover:text-brandPrimary focus:border-brandPrimary focus:text-brandPrimary   "
              }`}
              onClick={() => {
                saveRecipesToFolder();
                setDisableButtonRecipe(true);
                setSearch("");
                setDisableCloseButton(true);
              }}
              aria-label={aemModalData?.addRecipesToList ?? recipeModalData[0]?.addRecipesToList}
              disabled={
                disableButtonRecipe ||
                !!validationError ||
                !selectRecipe?.length
              }
            >
              {aemModalData?.addRecipesToList ?? recipeModalData[0]?.addRecipesToList}
            </Button>
          </Box>
        </Box>
      </DialogFooter>
    </Dialog>
  );
};
export default CreateListModal;
